module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/footer/mobile_BG-d9b878bd2547a620bfe3dacf8297b10f.svg";